import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  ConfirmationModal,
  Loading,
  FormatValueToDecimal,

  TaxationCodeSelect,
  VendorSelect, OrderStatusSelect, OrderStatusSelectWithAll,
  DateSelect,
  CurrencySelect
} from "../../common/APICommon";
import { v4 as uuidv4 } from "uuid";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export const PurchaseOrder = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.poNumber?.toLowerCase().includes(lowerValue) ||
        item.vendorName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion








//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [vendorFilter, setVendorFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion









//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([]);
  const [poNumber, setPONumber] = useState("xxxxxx");
  const [vendor, setVendor] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [poDate, setPODate] = useState(today);
  const [paymentTerms, setPaymentTerms] = useState("");
  const [currency, setCurrency] = useState("PHP");
  const [status, setStatus] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [reference, setReference] = useState("");
  const [notes, setNotes] = useState("");

  const resetVariables = () => {
    setPurchaseOrderDetails([]);
    setPONumber("xxxxxx");
    setVendor(null);
    setPODate(today);
    setPaymentTerms("");
    setCurrency("PHP");
    setStatus("");
    setSubTotal(0);
    setTotalDiscount(0);
    setTaxAmount(0);
    setTotalAmount(0);
    setReference("");
    setNotes("");

    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/PurchaseOrder/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion







// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      purchaseOrderDetails: purchaseOrderDetails,
      poNumber: poNumber,
      vendorId: vendor?.vendorId,
      poDate: poDate,
      paymentTerms: paymentTerms,
      currency: currency,
      status: status,
      subTotal: parseFloat(subTotal),
      totalDiscount: parseFloat(totalDiscount),
      taxAmount: parseFloat(taxAmount),
      totalAmount: parseFloat(totalAmount),
      reference: reference,
      notes: notes,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/PurchaseOrder`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setPurchaseOrderDetails(_data?.purchaseOrderDetails ?? []);
    setPONumber(_data?.poNumber ?? "");
    setVendor(_data?.vendor ?? null);
    setPODate(_data?.poDate ?? null);
    setPaymentTerms(_data?.paymentTerms);
    setCurrency(_data?.currency ?? "");
    setStatus(_data?.status ?? "");
    setSubTotal(_data?.subTotal ?? 0);
    setTotalDiscount(_data?.totalDiscount ?? 0);
    setTaxAmount(_data?.taxAmount ?? 0);
    setTotalAmount(_data?.totalAmount ?? 0);
    setReference(_data?.reference ?? "");
    setNotes(_data?.notes ?? "");

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      purchaseOrderDetails: purchaseOrderDetails,
      poNumber: poNumber,
      vendorId: vendor?.vendorId,
      poDate: poDate,
      paymentTerms: paymentTerms,
      currency: currency,
      status: status,
      subTotal: parseFloat(subTotal),
      totalDiscount: parseFloat(totalDiscount),
      taxAmount: parseFloat(taxAmount),
      totalAmount: parseFloat(totalAmount),
      reference: reference,
      notes: notes,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/PurchaseOrder/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion








// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setPurchaseOrderDetails(_data?.purchaseOrderDetails ?? []);
    setPONumber(_data?.poNumber ?? "");
    setVendor(_data?.vendor ?? null);
    setPODate(_data?.poDate ?? null);
    setPaymentTerms(_data?.paymentTerms);
    setCurrency(_data?.currency ?? "");
    setStatus(_data?.status ?? "");
    setSubTotal(_data?.subTotal ?? 0);
    setTotalDiscount(_data?.totalDiscount ?? 0);
    setTaxAmount(_data?.taxAmount ?? 0);
    setTotalAmount(_data?.totalAmount ?? 0);
    setReference(_data?.reference ?? "");
    setNotes(_data?.notes ?? "");

    setLoading(false)
    openViewForm();
  }
//#endregion









// #region View Items
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [showViewPurchaseOrderDetailForm, setShowViewPurchaseOrderDetailForm] = useState(false);
  
  const openViewPurchaseOrderDetailForm = () => {
    setShowViewPurchaseOrderDetailForm(true);
  }
  const closeViewPurchaseOrderDetailForm = () => {
    setShowViewPurchaseOrderDetailForm(false);
    setSelectedPurchaseOrder(null);
  }

  const viewPurchaseOrderDetailHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedPurchaseOrder(_data ?? null);

    setLoading(false)
    openViewPurchaseOrderDetailForm();
  }
// #endregion







//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'PO DETAILS', 
    'VENDOR', 
    'ITEMS', 
    'SUBTOTAL', 
    'TOTAL AMOUNT', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'po', 
    'vendor', 
    'purchaseOrderDetails', 
    'subTotal', 
    'totalAmount', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "View Items", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewPurchaseOrderDetailHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/PurchaseOrder/vendor/${vendorFilter?.vendorId ?? "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [vendorFilter, statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Order
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Purchase Orders"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Purchase Order"}

        data={data}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        poNumber={poNumber} setPONumber={setPONumber}
        vendor={vendor} setVendor={setVendor}
        poDate={poDate} setPODate={setPODate}
        paymentTerms={paymentTerms} setPaymentTerms={setPaymentTerms}
        currency={currency} setCurrency={setCurrency}
        status={status} setStatus={setStatus}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalDiscount={totalDiscount} setTotalDiscount={setTotalDiscount}
        taxAmount={taxAmount} setTaxAmount={setTaxAmount}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        reference={reference} setReference={setReference}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Purchase Order"}

        data={data}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        poNumber={poNumber} setPONumber={setPONumber}
        vendor={vendor} setVendor={setVendor}
        poDate={poDate} setPODate={setPODate}
        paymentTerms={paymentTerms} setPaymentTerms={setPaymentTerms}
        currency={currency} setCurrency={setCurrency}
        status={status} setStatus={setStatus}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalDiscount={totalDiscount} setTotalDiscount={setTotalDiscount}
        taxAmount={taxAmount} setTaxAmount={setTaxAmount}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        reference={reference} setReference={setReference}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleUpdateData}
        modalName={"View Purchase Order"}

        data={data}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        poNumber={poNumber} setPONumber={setPONumber}
        vendor={vendor} setVendor={setVendor}
        poDate={poDate} setPODate={setPODate}
        paymentTerms={paymentTerms} setPaymentTerms={setPaymentTerms}
        currency={currency} setCurrency={setCurrency}
        status={status} setStatus={setStatus}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalDiscount={totalDiscount} setTotalDiscount={setTotalDiscount}
        taxAmount={taxAmount} setTaxAmount={setTaxAmount}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}
        reference={reference} setReference={setReference}
        notes={notes} setNotes={setNotes}
        isEditable={false}
      />

      <ViewPurchaseOrderDetailModal
        visible={showViewPurchaseOrderDetailForm} 
        onClose={closeViewPurchaseOrderDetailForm} 
        modalName={"View Items"}
        data={selectedPurchaseOrder}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        vendorFilter={vendorFilter} setVendorFilter={setVendorFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/ View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  purchaseOrderDetails, setPurchaseOrderDetails,
  poNumber, setPONumber,
  vendor, setVendor,
  poDate, setPODate,
  paymentTerms, setPaymentTerms,
  currency, setCurrency,
  status, setStatus,
  subTotal, setSubTotal,
  totalDiscount, setTotalDiscount,
  taxAmount, setTaxAmount,
  totalAmount, setTotalAmount,
  reference, setReference,
  notes, setNotes,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [showPurchaseOrderDetails, setShowPurchaseOrderDetails] = useState(true);
  const [applyVat, setApplyVat] = useState(false);
  const [vatableAmount, setVatableAmount] = useState(0);

  useEffect(() => {
    if(vendor?.priceType === "Inclusive"){
      setApplyVat(true);
    }  else if (taxAmount){
      setApplyVat(true);
    }
  }, [vendor, taxAmount])

//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion









  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!poNumber
      || !poDate
      || !vendor
    ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }
    await onSave();
    closeModal();
  };

  const closeModal = () => {
    setFailMessage("");
    setApplyVat(false);
    setVatableAmount(0);
    onClose();
  };









//#region PurchaseOrderDetail
  const [currentPagePurchaseOrderDetail, setCurrentPagePurchaseOrderDetail] = useState(1);

  const headersPurchaseOrderDetail = [
    'ITEM CODE', 
    'ITEM DESCRIPTION', 
    'SUBTOTAL', 
    // 'TOTAL TAX', 
    'TOTAL DISCOUNT', 
    'TOTAL AMOUNT', 
    'ACTIONS'
  ]
  const accessorsPurchaseOrderDetail = [
    'itemCode', 
    'item', 
    'subTotal', 
    // 'taxAmount', 
    'totalDiscount',
    'totalAmount',
    'actions'
  ]

  const [showAddPurchaseOrderDetailForm, setShowAddPurchaseOrderDetailForm] = useState(false);
  const [selectedPurchaseOrderDetail, setSelectedPurchaseOrderDetail] = useState(null);
  const openAddPurchaseOrderDetailForm = () => {
    setShowAddPurchaseOrderDetailForm(true);
  }
  const closeAddPurchaseOrderDetailForm = () => {
    setShowAddPurchaseOrderDetailForm(false);
    setSelectedPurchaseOrderDetail(null)
  }

  const [showUpdatePurchaseOrderDetailForm, setShowUpdatePurchaseOrderDetailForm] = useState(false);
  const openUpdatePurchaseOrderDetailForm = () => {
    setShowUpdatePurchaseOrderDetailForm(true);
  }
  const closeUpdatePurchaseOrderDetailForm = () => {
    setShowUpdatePurchaseOrderDetailForm(false);
    setSelectedPurchaseOrderDetail(null)
  }

  const editHandlePurchaseOrderDetailClick = (_data) => {
    setSelectedPurchaseOrderDetail(_data)
    openUpdatePurchaseOrderDetailForm();
  }

  const [showDeletePurchaseOrderDetailForm, setShowDeletePurchaseOrderDetailForm] = useState(false);
  const openDeletePurchaseOrderDetailForm = () => {
    setShowDeletePurchaseOrderDetailForm(true);
  }
  const closeDeletePurchaseOrderDetailForm = () => {
    setShowDeletePurchaseOrderDetailForm(false);
    setSelectedPurchaseOrderDetail(null)
  }

  const deleteHandlePurchaseOrderDetailClick = (_data) => {
    setSelectedPurchaseOrderDetail(_data)
    openDeletePurchaseOrderDetailForm();
  }

  const handleDeletePurchaseOrderDetail = () => {
    setPurchaseOrderDetails(prev =>
      prev.filter(item =>
        (item.id ?? item.tempId) !==
        (selectedPurchaseOrderDetail.id ?? selectedPurchaseOrderDetail.tempId)
      )
    );
  };

  const [showItemDetailForm, setShowItemDetailForm] = useState(false);
  const openItemDetailForm = () => {
    setShowItemDetailForm(true);
  }
  const closeItemDetailForm = () => {
    setShowItemDetailForm(false);
  }

  const viewItemDetailHandleClick = (_data) => {
    setSelectedPurchaseOrderDetail(_data)
    openItemDetailForm()
  }

  const actionsPurchaseOrderDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewItemDetailHandleClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandlePurchaseOrderDetailClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandlePurchaseOrderDetailClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    if(visible){
      const _totalAmount = purchaseOrderDetails?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
      setTotalAmount(_totalAmount)
    }
  }, [purchaseOrderDetails, setTotalAmount, visible])

  useEffect(() => {
    if(visible){
      const _subTotal = purchaseOrderDetails?.reduce((acc, item) => acc + (Number(item.subTotal) || 0), 0) || 0;
      setSubTotal(_subTotal)

      // VAT Inclusive Computation (12%)
      let _vatableAmount = _subTotal;
      let _vat = 0;

      if(applyVat){
        _vatableAmount = _subTotal / 1.12;
        _vat = _subTotal - _vatableAmount;
      }

      setVatableAmount(Number(_vatableAmount.toFixed(2)));
      setTaxAmount(Number(_vat.toFixed(2)));
    }
  }, [purchaseOrderDetails, setSubTotal, setTaxAmount, applyVat, visible])

  /* useEffect(() => {
    const _taxAmount = purchaseOrderDetails?.reduce((acc, item) => acc + (Number(item.taxAmount) || 0), 0) || 0;
    setTaxAmount(_taxAmount)
  }, [purchaseOrderDetails, setTaxAmount]) */

  useEffect(() => {
    if(visible){
      const _totalDiscount = purchaseOrderDetails?.reduce((acc, item) => acc + (Number(item.totalDiscount) || 0), 0) || 0;
      setTotalDiscount(_totalDiscount)
    }
  }, [purchaseOrderDetails, setTotalDiscount, visible])
//#endregion 







  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Initital Information</h3>
                  </div>

                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                        {!vendor ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      PO Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. INV-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={poNumber}
                      onChange={(e) => setPONumber(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      PO Date <span className="text-red-500">*</span>
                    </label>
                    <DateSelect data={poDate} setData={setPODate} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Payment Terms
                    </label>
                    
                    <input
                      type="text"
                      placeholder="e.g. Due on Receipt"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={paymentTerms}
                      onChange={(e) => setPaymentTerms(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Status
                    </label>
                    <OrderStatusSelect data={status} setData={setStatus} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Currency
                    </label>
                    <CurrencySelect data={currency} setData={setCurrency} isEditable={isEditable}/>
                  </div>
                </>

                {/* --- Section 2: Purchase Order Details (Expandable) --- */}
                <div className="md:col-span-2 mt-4">
                  {/* Toggle Header Button */}
                  <button
                    type="button"
                    onClick={() => setShowPurchaseOrderDetails(!showPurchaseOrderDetails)}
                    className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showPurchaseOrderDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                        Purchase Order Details
                      </h3>
                      {/* Badge showing count */}
                      {purchaseOrderDetails?.length > 0 && (
                        <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                          {purchaseOrderDetails.length}
                        </span>
                      )}
                    </div>
                    
                    <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showPurchaseOrderDetails ? "rotate-180" : ""}`}>
                      <ExpandMoreIcon /> 
                    </div>
                  </button>

                  {/* Expandable Content Area */}
                  <AnimatePresence>
                    {showPurchaseOrderDetails && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="py-5 space-y-5">
                          {/* Add button */}
                          <div className="flex gap-3 w-full justify-start">
                            {isEditable &&
                              <button 
                                type="button"
                                onClick={openAddPurchaseOrderDetailForm} 
                                className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                              >
                                <AddCircleOutlineIcon fontSize="small" /> 
                                New Item
                              </button>
                            }
                          </div>

                          {/* List of Purchase Order Detail */}
                          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                            <CreateTable
                              tableName={"Purchase Order Detail"}
                              headers={headersPurchaseOrderDetail}
                              accessors={accessorsPurchaseOrderDetail}
                              data={purchaseOrderDetails}
                              actions={actionsPurchaseOrderDetail}
                              currentPage={currentPagePurchaseOrderDetail}
                              setCurrentPage={setCurrentPagePurchaseOrderDetail}
                              itemsPerPage={10}
                              totalItems={purchaseOrderDetails?.length}
                            />
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {/* Summary when collapsed (Optional) */}
                  {!showPurchaseOrderDetails && purchaseOrderDetails?.length > 0 && (
                    <motion.p 
                      initial={{ opacity: 0 }} 
                      animate={{ opacity: 1 }} 
                      className="text-[11px] text-gray-400 mt-2 italic"
                    >
                      Click to view {purchaseOrderDetails.length} line items...
                    </motion.p>
                  )}
                </div>

                {/* --- Section 3: Final Summary --- */}
                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>

                        {/* Mini Table for Subtotal, Discount, Tax */}
                        <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                          <div className="flex flex-row justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">APPLY VAT</span>
                            <div className="space-y-4">
                              <div>
                                <button
                                  type="button"
                                  onClick={(e) => setApplyVat(!applyVat)}
                                  className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                                    applyVat ? "bg-theme-color" : "bg-gray-400"
                                  }`}
                                >
                                  <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                      applyVat ? "translate-x-5" : "translate-x-1"
                                    }`}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Vatable Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}
                            </span>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">VAT</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                            </span>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Subtotal</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(subTotal)}
                            </span>
                          </div>
                          
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Total Discount</span>
                            <span className="text-sm font-semibold text-red-500">
                              - {getCurrency?.symbol} {FormatValueToDecimal(totalDiscount)}
                            </span>
                          </div>

                          <div className="justify-between items-center gap-8 hidden">
                            <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              + {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Total Amount
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {totalAmount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Full Width: Notes */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Notes
                  </label>
                  <textarea
                    rows="3"
                    placeholder="Enter any additional details or remarks..."
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    readOnly={!isEditable}
                  />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              { isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />

      <AddUpdateItemModal 
        visible={showAddPurchaseOrderDetailForm} 
        onClose={closeAddPurchaseOrderDetailForm}
        modalName={"Add Item"}
        data={selectedPurchaseOrderDetail}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        isEditable={true}
      />

      <AddUpdateItemModal 
        visible={showUpdatePurchaseOrderDetailForm} 
        onClose={closeUpdatePurchaseOrderDetailForm}
        modalName={"Update Item"}
        data={selectedPurchaseOrderDetail}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        isEditable={true}
      />

      <AddUpdateItemModal 
        visible={showItemDetailForm} 
        onClose={closeItemDetailForm}
        modalName={"View Item"}
        data={selectedPurchaseOrderDetail}
        purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        isEditable={false}
      />

      <ConfirmationModal 
        visible={showDeletePurchaseOrderDetailForm} 
        onClose={closeDeletePurchaseOrderDetailForm} 
        onSave={handleDeletePurchaseOrderDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this item [ ${selectedPurchaseOrderDetail?.itemCode ?? ""} ]?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  purchaseOrderDetails, setPurchaseOrderDetails,
  poNumber, setPONumber,
  vendor, setVendor,
  poDate, setPODate,
  paymentTerms, setPaymentTerms,
  currency, setCurrency,
  status, setStatus,
  subTotal, setSubTotal,
  totalDiscount, setTotalDiscount,
  taxAmount, setTaxAmount,
  totalAmount, setTotalAmount,
  reference, setReference,
  notes, setNotes,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Purchase_Order_${poNumber || 'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    await downloadHandleClick();
  };

  const closeModal = () => {
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Document Preview</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div ref={printRef} className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col">
                
                {/* PO DOCUMENT HEADER */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-10">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">PURCHASE ORDER</h1>
                    <div className="flex items-center gap-2">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${status === 'Approved' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                        {status || 'Draft'}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">P.O. Number</p>
                    <p className="text-2xl font-mono font-bold text-theme-color">#{poNumber || '---'}</p>
                    <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest">P.O. Date</p>
                    <p className="text-sm font-bold text-gray-800">{poDate ? new Date(poDate).toLocaleDateString() : 'N/A'}</p>
                  </div>
                </div>

                {/* INFO GRID */}
                <div className="grid grid-cols-2 gap-12 mb-12">
                  <div className="space-y-3">
                    <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-100 pb-2">Vendor Information</h3>
                    {vendor ? (
                      <div>
                        <p className="font-bold text-gray-900 text-lg">{vendor.name1 || vendor.Name1}</p>
                        <p className="text-sm text-gray-500">{vendor.name2 || vendor.Name2}</p>
                        <p className="text-xs text-gray-400 mt-2 font-mono">ID: {vendor.vendorId || vendor.VendorId}</p>
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-400">No vendor assigned</p>
                    )}
                  </div>
                  <div className="space-y-4 bg-gray-50 p-6 rounded-xl border border-gray-100">
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-gray-400 uppercase">Payment Terms</span>
                      <span className="text-sm font-bold text-gray-700">{paymentTerms || 'Standard'}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-gray-400 uppercase">Currency</span>
                      <span className="text-sm font-bold text-gray-700">{currency || getCurrency?.code || 'PHP'}</span>
                    </div>
                  </div>
                </div>

                {/* LINE ITEMS TABLE */}
                <div className="flex-grow">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-theme-color text-white">
                        <th className="py-3 px-4 text-left text-[10px] font-bold uppercase tracking-widest">Item</th>
                        <th className="py-3 px-4 text-center text-[10px] font-bold uppercase tracking-widest">Qty</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Unit Price</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">SubTotal</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest hidden">Tax</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Discount</th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Total</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 border-b border-gray-200">
                      {purchaseOrderDetails?.length > 0 ? (
                        purchaseOrderDetails.map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-5 px-4">
                              <p className="text-sm font-bold text-gray-800">{`${item.itemDescription ?? ""} ${item.brandName ?? ""}` || 'Default Item'}</p>
                              {item.notes && <p className="text-[10px] text-gray-400 mt-1 italic">{item.notes}</p>}
                            </td>
                            <td className="py-5 px-4 text-center text-sm font-medium text-gray-600">
                              {`${item.quantity} ${item.uomName ?? ""}`}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-medium text-gray-600">
                              {getCurrency?.symbol} {formatVal(item.unitPrice)}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                              {getCurrency?.symbol} {formatVal(item.subTotal)}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-bold text-gray-900 hidden">
                              {getCurrency?.symbol} {formatVal(item.taxAmount)}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                              {getCurrency?.symbol} {formatVal(item.totalDiscount)}
                            </td>
                            <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                              {getCurrency?.symbol} {formatVal(item.totalAmount)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No items found in this order</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* TOTALS SECTION */}
                <div className="mt-10 flex justify-between items-start">
                  <div className="max-w-sm">
                    <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Notes</h4>
                    <p className="text-xs text-gray-500 leading-relaxed bg-gray-50 p-4 rounded-lg border border-dashed border-gray-200">
                      {notes || "No special instructions provided."}
                    </p>
                  </div>
                  <div className="w-64 space-y-3">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-400 font-medium">Subtotal</span>
                      <span className="text-gray-700 font-bold">{getCurrency?.symbol} {formatVal(subTotal)}</span>
                    </div>
                    <div className="hidden justify-between text-sm">
                      <span className="text-gray-400 font-medium">Tax</span>
                      <span className="text-gray-700 font-bold">{getCurrency?.symbol} {formatVal(taxAmount)}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-400 font-medium">Discount</span>
                      <span className="text-red-500 font-bold">-{getCurrency?.symbol} {formatVal(totalDiscount)}</span>
                    </div>
                    <div className="flex justify-between items-center pt-4 border-t-2 border-theme-color">
                      <span className="text-xs font-black text-gray-900 uppercase">Grand Total</span>
                      <span className="text-2xl font-black text-theme-color">
                        {getCurrency?.symbol} {formatVal(totalAmount)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating PDF...
                    </>
                ) : 'Download PDF'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion








//#region Item
const AddUpdateItemModal = ({
  visible, onClose, onSave, modalName,
  data,
  purchaseOrderDetails, setPurchaseOrderDetails,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemDescription, setItemDescription] = useState("");
  const [uomName, setUomName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [taxationCode, setTaxationCode] = useState(null);
  const [notes, setNotes] = useState("");

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (quantity <= 0 || unitPrice <= 0 || !itemCode) {
      setFailMessage("Please fill up all required fields.");
      return;
    }

    if(modalName === "Add Item"){
      const newData = {
        id: null,
        tempId: uuidv4(),
        itemCode: itemCode,
        itemDescription: itemDescription,
        uomName: uomName,
        brandName: brandName,
        categoryName: categoryName,
        quantity: parseFloat(quantity),
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        unitPrice: parseFloat(unitPrice),
        subTotal: parseFloat(subTotal),
        totalDiscount: parseFloat(totalDiscount),
        taxAmount: parseFloat(taxAmount),
        totalAmount: parseFloat(totalAmount),
        notes: notes,
      }

      setPurchaseOrderDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Item"){
      const newData = {
        ...data,
        itemCode: itemCode,
        itemDescription: itemDescription,
        uomName: uomName,
        brandName: brandName,
        categoryName: categoryName,
        quantity: parseFloat(quantity),
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        unitPrice: parseFloat(unitPrice),
        subTotal: parseFloat(subTotal),
        totalDiscount: parseFloat(totalDiscount),
        taxAmount: parseFloat(taxAmount),
        totalAmount: parseFloat(totalAmount),
        notes: notes,
      }

      setPurchaseOrderDetails(prev =>
        prev.map(item =>
          (item.id ?? item.tempId) === (data.id ?? data.tempId)
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setItemCode("");
    setItemDescription("");
    setUomName("");
    setBrandName("");
    setCategoryName("");
    setQuantity(0);
    setUnitPrice(0);
    setSubTotal(0);
    setTotalDiscount(0);
    setTaxAmount(0);
    setTotalAmount(0);
    setTaxationCode(null);
    setNotes("");
  };

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if (visible && data) {
      setItemCode(data?.itemCode ?? "");
      setItemDescription(data?.itemDescription ?? "");
      setUomName(data?.uomName ?? "");
      setBrandName(data?.brandName ?? "");
      setCategoryName(data?.categoryName ?? "");
      setQuantity(data?.quantity ?? 0);
      setUnitPrice(data?.unitPrice ?? 0);
      setSubTotal(data?.subTotal ?? 0);
      setTotalDiscount(data?.totalDiscount ?? 0);
      setTaxAmount(data?.taxAmount ?? 0);
      setTotalAmount(data?.totalAmount ?? 0);
      setTaxationCode(data?.taxationCode ?? null);
      setNotes(data?.notes ?? "");
    }
  }, [visible, data]);

  const toNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? 0 : n;
  };

  useEffect(() => {
    const taxedAmount =
      toNumber(subTotal) + toNumber(taxAmount);

    const _totalAmount =
      taxedAmount - toNumber(totalDiscount);

    setTotalAmount(_totalAmount);
  }, [subTotal, taxAmount, totalDiscount]);

  useEffect(() => {
    const _subTotal =
      toNumber(unitPrice) * toNumber(quantity);

    setSubTotal(_subTotal);
  }, [unitPrice, quantity]);


  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the item details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      placeholder="0000-0000"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={itemCode}
                      onChange={(e) => setItemCode(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item Description
                    </label>
                    <input
                      placeholder="ITEM-1"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={itemDescription}
                      onChange={(e) => setItemDescription(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Brand
                    </label>
                    <input
                      placeholder="BRAND-X"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={brandName}
                      onChange={(e) => setBrandName(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Category
                    </label>
                    <input
                      placeholder="CATEGORY-X"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Unit of Measure
                    </label>
                    <input
                      placeholder="pieces"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={uomName}
                      onChange={(e) => setUomName(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Quantity <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Unit Price <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(unitPrice || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Taxation Code
                    </label>
                    <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={isEditable}/>
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Tax Amount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={taxAmount}
                      onChange={(e) => setTaxAmount(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(taxAmount || 0)}
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Discount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={totalDiscount}
                      onChange={(e) => setTotalDiscount(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(totalDiscount || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      {/* Left Side: Details Breakdown */}
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Transaction Summary
                            </p>
                            <p className="text-xs text-gray-500">Breakdown of all line items</p>
                          </div>

                          {/* Mini Table for Subtotal, Discount, Tax */}
                          <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Subtotal</span>
                              <span className="text-sm font-semibold text-gray-700">
                                {getCurrency?.symbol} {FormatValueToDecimal(subTotal)}
                              </span>
                            </div>
                            
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Total Discount</span>
                              <span className="text-sm font-semibold text-red-500">
                                - {getCurrency?.symbol} {FormatValueToDecimal(totalDiscount)}
                              </span>
                            </div>

                            <div className="hidden justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                              <span className="text-sm font-semibold text-gray-700">
                                + {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Side: Final Total & Status */}
                      <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                          Final Total Amount
                        </p>
                        <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                          <span className="text-4xl font-black text-gray-900 tracking-tight">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalAmount)}`}
                          </span>
                        </div>

                        {/* Visual indicator of validation */}
                        {totalAmount > 0 ? (
                          <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                            <span className="mr-1">●</span> Ready to Save
                          </span>
                        ) : (
                          <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                            <span className="mr-1">○</span> No amount detected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Notes
                    </label>
                    <textarea
                      rows="3"
                      placeholder="Enter any additional details or remarks..."
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewPurchaseOrderDetailModal = ({
  visible, onClose, onSave, modalName,
  data,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const closeModal = () => {
    onClose();
  };

  const [selectedItemDetail, setSelectedItemDetail] = useState(null);
  const [showItemDetailForm, setShowItemDetailForm] = useState(false);
  const openItemDetailForm = () => {
    setShowItemDetailForm(true);
  }
  const closeItemDetailForm = () => {
    setShowItemDetailForm(false);
  }

  const viewItemDetailHandleClick = (_data) => {
    setSelectedItemDetail(_data)
    openItemDetailForm()
  }

  const [currentPagePurchaseOrderDetail, setCurrentPagePurchaseOrderDetail] = useState(1);

  const headersPurchaseOrderDetail = [
    'ITEM CODE', 
    'ITEM DESCRIPTION', 
    'SUBTOTAL', 
    // 'TOTAL TAX', 
    'TOTAL DISCOUNT', 
    'TOTAL AMOUNT', 
    'ACTIONS'
  ]
  const accessorsPurchaseOrderDetail = [
    'itemCode', 
    'item', 
    'subTotal', 
    // 'taxAmount', 
    'totalDiscount',
    'totalAmount',
    'actions'
  ]

  const actionsPurchaseOrderDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewItemDetailHandleClick,
      visible: true,
    },
  ];

  const [vatableAmount, setVatableAmount] = useState(0)

  useEffect(() => {
    if(data?.taxAmount > 0){
      const _vatableAmount = (data?.subTotal ?? 0) - (data?.taxAmount ?? 0)
      setVatableAmount(_vatableAmount)
    }
  }, [data])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Purchase Order Detail"}
                    headers={headersPurchaseOrderDetail}
                    accessors={accessorsPurchaseOrderDetail}
                    data={data?.purchaseOrderDetails}
                    actions={actionsPurchaseOrderDetail}
                    currentPage={currentPagePurchaseOrderDetail}
                    setCurrentPage={setCurrentPagePurchaseOrderDetail}
                    itemsPerPage={10}
                    totalItems={data?.purchaseOrderDetails?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>

                        {/* Mini Table for Subtotal, Discount, Tax */}
                        <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Vatable Amt</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}
                            </span>
                          </div>
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Tax</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(data?.taxAmount)}
                            </span>
                          </div>
                          <div className="flex justify-between items-center gap-8 border-t">
                            <span className="text-xs font-medium text-gray-500">Subtotal</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(data?.subTotal)}
                            </span>
                          </div>
                          
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Total Discount</span>
                            <span className="text-sm font-semibold text-red-500">
                              - {getCurrency?.symbol} {FormatValueToDecimal(data?.totalDiscount)}
                            </span>
                          </div>

                          <div className="hidden justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              + {getCurrency?.symbol} {FormatValueToDecimal(data?.taxAmount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Total Amount
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(data?.totalAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {data?.totalAmount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateItemModal 
        visible={showItemDetailForm} 
        onClose={closeItemDetailForm}
        modalName={"View Item"}
        data={selectedItemDetail}
        // purchaseOrderDetails={purchaseOrderDetails} setPurchaseOrderDetails={setPurchaseOrderDetails}
        isEditable={false}
      />
    </>
  );
};
//#endregion








//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  vendorFilter, setVendorFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_vendorFilter, _setVendorFilter] = useState(vendorFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setVendorFilter(vendorFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, vendorFilter, statusFilter])

  const handleSubmit = async () => {
    setVendorFilter(_vendorFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };



//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_vendorFilter ? `${_vendorFilter?.vendorId} - ${_vendorFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_vendorFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setVendorFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <OrderStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={_vendorFilter} setData={_setVendorFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion